<style lang="less" scoped>
  .terms-container {
    padding: 60px 0;
  }
  .title {
    font-size: 20px;
  }
  .terms-item-list {
    display: flex;
    flex-flow: column wrap;
    padding: 20px 0;
  }
  .terms-item {
    margin: 20px 0;
  }
  .terms-box {
    border: 1px solid #e3e3e3;
    border-radius: 5px;
  }
  .terms-box-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 51px;
    border-bottom: 1px solid #e3e3e3;
    padding: 0 16px;
  }
  .terms-box-title {
    color: #808080;
  }
  .date {
    font-size: 13px;
    color: #b0b0b0;
  }
  .terms-box-body {
    padding: 16px;
    background-color: #f7f7f7;
    line-height: 18px;
    font-size: 13px;
    color: #808080;
    height: 200px;
    overflow-y: scroll;
  }
  .checkbox {
    margin-top: 16px;
  }
  .validation-section {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 162px;
    margin-top: 20px;
    border: 1px solid #e3e3e3;
    border-radius: 5px;
    padding: 16px;
  }
  .validation-section-title {
    position: absolute;
    top: 16px;
    left: 16px;
    color: #808080;
  }
  .form {
    display: flex;
  }
  .auth-button {
    margin-left: 10px;
    border-color: #ff6c00;
    color: #ff6c00;
  }
  .business-nubmer-input {
    width: 180px;
    .el-input__inner:read-only {
      color: #67c23a;
      background-color: #f0f9eb;
    }
  }
  .next-button-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 60px;
  }
  .next-button {
    width: 120px;
    height: 50px;
  }
</style>

<template lang="pug">
  .terms-container
    h1.title 약관동의
    .terms-item-list
      .terms-item
        .terms-box
          .terms-box-header
            p.terms-box-title 서비스 이용약관
            p.date 2013.09.01 시행
          .terms-box-body.
            제 1 조 (목적)#[br]
            이 약관(이하 "약관"이라고 합니다)은 주식회사 스타일닷컴(이하 "회사"라고 합니다)이 제공하는 스타일닷컴광고와 스타일닷컴과 제휴되어 있는 파트너매체에서 노출되는 쇼핑몰광고 / 상품광고 / 모바일광고 / 배너광고 / 쇼핑몰에서 판매되는 상품정보를 이용한 광고상품 등을 이야기 하며 (이하 "스타일닷컴 광고" 라고 합니다) 관련 제반 서비스의 이용과 관련하여 "광고주"와 "회사" 간에 필요한 사항을 규정함을 목적으로 합니다.#[br]#[br]
            제 2 조 (정의)#[br]
            "약관"에서 사용하는 용어의 정의는 아래와 같습니다.#[br]
            ① "스타일닷컴 광고"라 함은 검색서비스 ,추천쇼핑몰등 "회사"가 정한 방식에 따라 광고주가 신청한 광고컨텐츠를 광고매체 이용자에게 보여주는 방식의 인터넷 광고를 의미합니다.#[br]
            ② "스타일닷컴 광고 서비스"(이하 "서비스"라고 합니다)라 함은 "회사"가 제공하는 "검색서비스" 및 "추천쇼핑몰"에 부수되는 제반 서비스를 의미합니다.#[br]
            ③ "광고매체"라 함은 스타일닷컴 또는 스타일닷컴과 제휴되어 있는 웹사이트, 모바일웹사이트, 모바일 어플리케이션 서비스 기타 응용프로그램에 의해 "패키지광고"가 게재되는 매체를 의미합니다.#[br]
            ④ "광고주"라 함은 "서비스"를 이용하기 위해 "약관"에 따라 "회사"와 이용계약을 체결하고 "회사"가 제공하는 "서비스"를 이용하는 이용고객을 의미합니다.#[br]
            ⑤ "마케팅센터"라 함은 "광고주"가 "스타일닷컴 광고"의 신청, 게재, 관리, 취소 등을 위해 "회사"가 제공하는 "서비스" 중 "스타일닷컴 광고" 관리 서비스를 제공하는 웹사이트를 의미합니다.#[br]
            ⑥ "광고주계정"이라 함은 "광고주"가 "스타일닷컴 광고"의 신청, 게재, 관리, 취소 등을 하기 위해 "마케팅센터"를 이용할 수 있도록, "광고주"가 등록을 신청하면 "회사"가 "광고주" 에게 부여하는 식별정보를 의미합니다.#[br]
            ⑦ "광고소재"라 함은 "광고주"가 게재 신청하여 "광고매체"에 게재되는 이미지, 상품, 제목, 설명문구, 부가정보, 등 광고 내용을 의미합니다.#[br]
            ⑧ "비즈포인트"라 함은 "스타일닷컴 광고"를 이용하기 위해 사용할 수 있는 포인트로 "스타일닷컴 광고"의 이용 시 서비스 개념으로 제공되는 포인트이며 비즈포인트는 환불이 불가능 합니다#[br]
            ⑨ "광고매체 이용자"라 함은 "광고매체"를 이용하는 이용자를 의미하며, "광고매체" 운영 주체의 회원 또는 비회원 모두를 포함합니다.#[br]#[br]
            제 3 조 (약관의 게시와 개정)#[br]
            ① "회사"는 "약관"의 내용을 "광고주"가 쉽게 알 수 있도록 "마케팅센터" 초기화면 또는 연결화면을 통하여 게시합니다.#[br]
            ② "회사"는 필요한 경우 관련 법령을 위배하지 않는 범위 내에서 "약관"을 개정할 수 있습니다.#[br]
            ③ "회사"는 "약관"을 개정할 경우 개정내용과 적용일자를 명시하여 "마케팅센터"에서 적용일자 7일전부터 적용일자 전일까지 공지합니다. 다만, "광고주"에게 불리하게 개정되는 경우 적용일자 30일 전부터 공지합니다.#[br]
            ④ "회사"가 전항에 따라 공지하면서 "광고주"에게 적용일자 전일까지 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 명확하게 공지하거나 제12조에 따른 방법으로 통지하였음에도 "광고주"가 명시적으로 거부의 의사표시를 하지 않은 경우 "광고주"가 개정 약관에 동의한 것으로 봅니다.#[br]
            ⑤ "광고주"는 개정 약관에 동의하지 않는 경우 적용일자 전일까지 "회사"에 거부의사를 표시하고 "광고주" 탈퇴를 할 수 있습니다.#[br]#[br]
            제 4 조 (기업회원 가입)#[br]
            ① "기업회원" 가입 시 회사가 "기업회원"의 쇼핑몰에서 취급되는 상품정보(이미지,가격,상품명,후기 등 상품을 구성하는 모든정보)를 수집하고 재가공하는것에 대해 동의하며 해당 정보는 스타일닷컴 마케팅 및 마케팅파트너 또는 제3자에게 제공되것에 대해 동의하는걸로 간주합니다.#[br]
            ② "기업회원" 가입 시 제공한 회원정보 및 수집되어 재가공된 상품정보의 저작권 및 권리는 "회사"에 있으며 이를 바탕으로 쇼핑몰은 트래픽을 공급받는것에 동의합니다.#[br]#[br]
            제 5 조 (광고주 가입)#[br]
            ① "광고주" 가입은 "서비스"를 이용하고자 하는 자(이하 "가입신청자"라고 합니다)가 "약관"의 내용에 동의를 한 다음 "회사""가 정한 절차에 따라 가입신청을 하면, "회사"가 이러한 신청에 대하여 승낙함으로써 체결됩니다.#[br]
            ② "회사"는 "가입신청자"의 신청에 대하여 아래 각 호의 사유가 있는 경우에는 승낙을 하지 않을 수 있으며, 가입 이후에도 아래 각 호의 사유가 확인될 경우에는 "광고주" 직권 해지 조치를 할 수 있습니다.#[br]
            "가입신청자"가 "약관"에 의하여 이전에 "광고주" 자격을 상실한 적이 있는 경우#[br]
            "가입신청자"가 "약관" 위반 등의 사유로 "서비스" 이용제한 중에 "광고주" 탈퇴 후 재가입신청을 하는 경우#[br]
            실명이 아닌 명의 또는 타인의 명의를 기재한 경우#[br]
            허위 또는 잘못된 정보를 기재 또는 제공하거나 "회사"가 제시하는 사항을 기재하지 않은 경우#[br]
            "가입신청자"의 귀책사유로 인하여 승낙이 불가능하거나 기타 "약관"에서 규정한 제반 사항을 위반하여 신청하는 경우#[br]
            ③ 제1항에 따른 신청에 대하여 "회사"는 전문기관을 통한 실명확인 및 본인인증을 "가입신청자"에게 요청할 수 있습니다.#[br]
            ④ "광고주" 가입의 성립 시기는 "회사"가 가입 완료를 신청절차상에서 표시하거나, 제12조의 방식에 따른 통지가 "가입신청자"에게 도달한 시점으로 합니다.#[br]#[br]
            제 6 조 (광고주계정 관리 의무)#[br]
            ① "광고주계정"의 아이디와 비밀번호에 대한 관리책임은 "광고주"에게 있으며, "광고주"는 이를 제3자가 이용하도록 하여서는 안됩니다.#[br]
            ② "광고주"는 아이디 또는 비밀번호가 도용되거나 제3자가 이용하고 있음을 안 경우, 이를 즉시 "회사"에 통지하고 "회사"의 안내에 따라야 합니다.#[br]
            ③ "광고주"는 가입 신청 시 기재한 사항이 변경되었을 경우 "마케팅센터"에 접속하여 직접 수정하거나 고객센터를 통하여 "회사"에 변경 사항을 통지하여야 합니다.#[br]
            ④ 사업자등록번호를 기재하여 가입한 "광고주"는 휴업 또는 폐업 상태가 되었을 경우 "회사"가 정하는 절차에 따라 "회사"에 정보 수정을 요청하여야 합니다.#[br]
            ⑤ "광고주"가 제2항, 제3항, 제4항을 준수하지 않아 발생한 불이익에 대하여 "회사"는 책임을 지지 않습니다.#[br]#[br]
            제 7 조 (개인정보의 보호)#[br]
            "회사"는 "정보통신망 이용촉진 및 정보보호 등에 관한 법률", "개인정보보호법" 등 관련 법령이 정하는 바에 따라 "광고주"의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련 법령 및 "회사"의 개인정보취급방침이 적용됩니다. 다만, "회사"의 공식 사이트 이외의 링크된 사이트에서는 "회사"의 개인정보취급방침이 적용되지 않습니다.#[br]
            (개인정보보호정책: http://mkc.sta1.com/)#[br]#[br]
            제 8 조 (스타일닷컴 광고 이용계약 체결)#[br]
            ① "스타일닷컴 광고" 이용계약은 "광고주"가 "회사"가 정한 절차에 따라 "스타일닷컴 광고" 게재를 신청하고 "회사"가 이를 승낙함으로써 체결되며, "회사"는 구체적인 신청 및 승낙 절차에 대해 "마케팅센터"를 통해 안내할 수 있습니다.#[br]
            ② "광고주"는 반드시 "회사"가 요구하는 양식과 절차를 통해 "스타일닷컴 광고" 게재를 신청해야 합니다. "회사"는 "광고주"의 신청에 대해 심사기준, 승낙 여부나 방식 등을 결정할 권한을 가지며, 관련 법령 및 "회사"의 기준에 따라 "광고주"에게 신청한 내용의 변경을 요청할 수 있습니다.#[br]
            ③ "광고주"의 변경 요청 거절, "회사"의 미승낙 등의 사유로 "스타일닷컴 광고" 이용계약이 체결되지 않은 경우, "광고주"는 "회사"에 해당 "스타일닷컴 광고"의 신청을 이유로 지급한 "비즈머니"의 환급 또는 환불을 요청할 수 있습니다.#[br]
            ④ "광고주"는 이용계약 체결 후 "서비스"를 이용하는 중에 "스타일닷컴 광고"의 대상이 된 웹사이트, 상품, 서비스 또는 그 제공자에 변경 사항이 발생한 경우 지체 없이 "회사"에 이를 통지하여 재심사를 받아야 하며, 재심사로 인해 발생하는 불이익은 "광고주"가 부담합니다.#[br]
            ⑤ "광고주"는 "회사"에 대해 자신이 게재 신청하는 "스타일닷컴 광고"의 "광고소재" 및 "스타일닷컴 광고"의 대상이 된 웹사이트, 상품, 서비스 또는 그 제공자가 관련 법령을 위반하거나 제 3자의 권리를 침해하지 않음을 보증합니다. 또한, "광고소재" 및 "스타일닷컴 광고"의 대상이 된 웹사이트, 상품, 서비스 또는 그 제공자와 관련하여 분쟁이 발생하는 경우 "광고주"는 자신의 책임과 비용으로 "회사"를 면책시키고 이로 인해 "회사"에 발생한 손해를 배상합니다.#[br]
            ⑥ "회사"가 본 조에 따라 "스타일닷컴 광고" 게재 신청을 승낙한 것이 해당 "스타일닷컴 광고"의 "광고소재" 또는 해당 "스타일닷컴 광고"의 대상이 된 웹사이트, 상품, 서비스 또는 그 제공자가 위법하지 않거나 "회사"의 "약관"이나 광고운영정책, 이용안내 등에 적합함을 최종적으로 보증하거나 보장하는 것은 아니며 승낙 이후에도 "광고소재" 또는 웹사이트, 상품, 서비스 등이 관련 법령 또는 "약관"이나 광고운영정책, 이용안내 등에 위반하는 것이 확인될 경우 "회사"는 제19조에 따라 "스타일닷컴 광고" 이용계약을 해지할 수 있습니다.#[br]#[br]
            제 9 조 (서비스의 내용)#[br]
            ① "스타일닷컴 광고"는 아래 각 호와 같이 구분됩니다.#[br]
            검색형 상품광고: "광고매체 이용자"가 "광고매체"에서 질의를 발생시킨 경우, 카테고리를 클릭한 경우 "광고주"가 신청하고 "회사"가 승낙한 광고를 "회사"가 정한 방식에 따라 "광고매체"에 게재하는 것을 말합니다.#[br]
            콘텐츠형 상품광고: "광고매체 이용자"가 "광고매체"를 이용할 경우, "광고주"가 신청하고 "회사"가 승낙한 광고를 "회사"가 정한 방식에 따라 "광고매체"에 게재하는 것을 말합니다.#[br]
            ② "회사"는 "스타일닷컴 광고"의 신청 절차 및 게재 영역, 기타 "서비스" 내용 등을 "마케팅센터"를 통해 안내할 수 있으며 "광고주"는 "스타일닷컴 광고" 이용계약 체결 전에 이를 신중히 확인하여야 합니다.#[br]#[br]
            제 10 조 (스타일닷컴 광고의 게재)#[br]
            ① "회사"는 "스타일닷컴 광고"가 게재되는 "광고매체"의 범위 및 "광고매체"에서의 "스타일닷컴 광고" 게재영역, 게재 순서, 게재 정보, 게재 영역의 UI 등(이하 "게재 영역 등"이라고 합니다)에 대한 결정 권한을 가지며, 변경 또는 추가할 수 있습니다.#[br]
            ② "광고매체"의 범위에 변경이 있는 경우 "회사"는 그 변경 전에 "마케팅센터" 내 게시판에 공지합니다. "광고주"는 변경 내용에 동의하지 않을 경우 언제든지 자신의 "광고주계정"에서 변경된 내용으로 게재되는 "스타일닷컴 광고"의 노출을 중단할 수 있습니다.#[br]
            ③ "회사"는 수시로 "서비스"의 품질 향상 및 "스타일닷컴 광고"의 효과 증대 등을 위해 일부 트래픽을 대상으로 하는 테스트를 별도의 공지 없이 진행할 수 있습니다.#[br]
            ④ "회사"는 "스타일닷컴 광고"가 아래 각 호에 해당하는 경우 "스타일닷컴 광고"의 게재를 제한하거나 게재되는 "스타일닷컴 광고"의 수를 제한할 수 있습니다. "스타일닷컴 광고"의 게재 및 게재 가능 광고의 수 제한에 대한 구체적인 기준 등에 대해서는 광고운영정책에서 정합니다.#[br]
            "회사"에 법률적 또는 재산적 위험을 발생시키거나 발생시킬 우려가 있는 경우#[br]
            "회사" 및 "광고매체"의 명예?평판?신용이나 신뢰도를 훼손하거나 훼손할 우려가 있는 경우#[br]
            "서비스" 또는 "광고매체"의 품질을 저하시키거나 저하시킬 우려가 있는 경우#[br]
            "스타일닷컴 광고"의 효과가 현저히 떨어지는 경우#[br]
            ⑤ "광고매체"의 운영 주체가 정당하고 합리적인 이유를 근거로 자신의 "광고매체"에서 특정 "스타일닷컴 광고"의 게재 제한이나 "게재 영역 등"의 변경을 요청하는 경우 "회사"는 해당 "스타일닷컴 광고"의 게재를 제한하거나 "게재 영역 등"을 변경할 수 있습니다. 이 경우 "회사"는 제12조에 따른 방법으로 "광고주"에게 통지하며, 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.#[br]#[br]
            제 11 조 (서비스의 변경)#[br]
            ① "회사"는 안정적인 "서비스" 제공을 위하여 "서비스"의 내용, 운영상 또는 기술상 사항 등을 변경할 수 있습니다.#[br]
            ② "회사"는 "서비스"를 변경할 경우 변경내용과 적용일자를 명시하여 "마케팅센터"에서 사전에 공지합니다. 단, "광고주"의 권리나 의무 및 "서비스" 이용과 관련되는 실질적인 사항을 변경할 경우 적용일자 7일전부터 공지하며, "광고주"에게 불리한 변경의 경우 적용일자 30일전부터 공지합니다.#[br]
            ③ "광고주"는 "서비스" 변경에 동의하지 않을 경우 "회사"에 거부의사를 표시하고 "광고주" 탈퇴를 할 수 있습니다.#[br]#[br]
            제 12 조 (서비스의 중단)#[br]
            ① "회사"는 컴퓨터 등 정보통신설비의 보수점검, 교체, 고장, 장애, 통신두절 또는 운영상 합리적인 사유가 있는 경우 "서비스" 제공을 일시적으로 중단할 수 있습니다.#[br]
            ② 전항의 경우 "회사"는 제12조에 따른 방법으로 "광고주"에게 통지합니다. 다만, "회사"가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.#[br]
            ③ "회사"는 제1항에 따른 "서비스" 제공 중단으로 발생한 "광고주"의 손해에 대하여 고의 또는 과실이 없는 한 책임을 지지 않습니다.#[br]#[br]
            제 13 조 (광고주에 대한 통지)#[br]
            ① "회사"가 "광고주"에 대하여 통지를 하는 경우 "약관"에 별도의 규정이 없는 한 "광고주"가 제공한 전자우편주소, (휴대)전화번호, 주소 등으로 할 수 있습니다.#[br]
            ② "회사"는 "광고주" 전체에 대하여 통지를 하는 경우 7일 이상 "마케팅센터" 내 게시판에 게시함으로써 전항의 통지에 갈음할 수 있습니다. 다만, "광고주"의 "서비스" 이용에 중대한 영향을 주는 사항에 대해서는 전항에 따른 방법으로 통지합니다.#[br]
            ③ "회사"가 제1항의 방법에 따라 정상적으로 발송하거나, 제2항의 방법에 따라 게시하는 경우 통지가 도달한 것으로 보며, "광고주"가 "회사"에 제공한 전자우편주소, (휴대)전화번호, 주소 등이 사실과 다르거나, "광고주"가 통지를 확인하지 않아 발생한 문제에 대하여 "회사"는 책임을 지지 않습니다.#[br]#[br]
            제 14 조 (서비스 이용료 등)#[br]
            ① "스타일닷컴 광고"의 서비스 이용료는 대금지급 방식에 따라 정액제와 종량제로 구분되며, "광고주"는 각 상품별 특성에 따라 서비스 이용료를 광고의 게재 전에 비즈머니로 충전 또는 지급하여야 합니다.#[br]
            ② "스타일닷컴 광고"의 구매방식은 입찰제와 선착순 등으로 분류되며, "광고주"는 "회사"가 정한 절차와 방식에 따라 구매에 참여하여야 합니다.#[br]
            ③ "광고주"가 "마케팅센터" 또는 "회사"가 정한 절차에 따라 "회사"가 "광고주"를 대신하여 제3자에게 서비스 이용료 등 "서비스" 이용과 관련한 금원을 세금계산서 발행 등의 방식으로 청구할 것을 요청할 경우 "회사"는 이에 대하여 동의할 수 있습니다. 단, "회사"는 "광고주"의 요청을 거절할 수 있습니다.#[br]
            ④ "광고주"가 지정한 제3자는 "회사"가 지정한 절차를 준수하여야 하며, "광고주"가 지정한 제3자가 서비스 이용료 등 "서비스"와 관련한 금원을 적기에 "회사"에 납부하지 않을 경우 또는 "회사"가 발행한 세금계산서의 수령을 거절할 경우 "회사"는 "광고주"에게 세금계산서를 발행하고 해당 금원을 청구할 수 있으며, "광고주"는 즉시 "회사"에 납부하여야 합니다. "광고주"가 지정한 제3자의 세금계산서 수령 거절 등의 사유로 "회사"에 손해가 발생할 경우 해당 손해에 대해서는 "광고주"가 모든 책임을 부담합니다.#[br]#[br]
            제 15 조 (회사의 의무)#[br]
            ① "회사"는 관련 법령과 "약관"을 준수하며, 계속적이고 안정적으로 "서비스"를 제공하기 위하여 최선을 다하여 노력합니다.#[br]
            ② "회사"는 "광고주"가 안전하게 "서비스"를 이용할 수 있도록 개인정보(신용정보 포함) 보호를 위하여 보안시스템을 갖추어야 하며 개인정보취급방침을 공시하고 준수합니다.#[br]
            ③ "회사"는 "서비스" 이용과 관련하여 "광고주"로부터 제기된 의견이나 불만이 정당하다고 인정될 경우 이를 처리하여야 하며, "마케팅센터" 내 게시판, 전자우편 등을 통하여 "광고주"에게 처리과정 및 결과를 전달할 수 있습니다.#[br]#[br]
            제 16 조 (광고주의 의무)#[br]
            ① "광고주"는 관련 법령, "약관", 광고운영정책, 이용안내 및 "회사"가 공지하거나 통지한 사항 등을 준수하여야 하며, 기타 "회사"의 업무에 방해되는 행위를 하여서는 안 됩니다. (예)광고주 웹사이트가 불법정보를 담고 있거나 법령을 위반하는 내용으로 구성하는 경우 등 포함)#[br]
            ② "광고주"는 "광고주계정"을 "서비스"를 이용하기 위한 용도(예)광고주 정보관리, 키워드관리, 이용료결제 등)로만 사용하여야 합니다.#[br]
            ③ "광고주"는 어떠한 경우에도 "회사"의 사전 승낙 없이 아래와 같은 행위를 하는 에이전트(agent), 로봇(robot), 스크립트(script), 스파이더(spider), 스파이웨어(spyware) 등의 수단을 제작, 배포, 설치하거나 이를 유도하여서는 안되며 기타 부정한 방법 등을 통해 아래와 같은 행위를 하거나 그러한 시도를 하여서는 안됩니다.#[br]
            "회사"가 제공하지 않는 방식으로 "서비스"에 접속하는 행위#[br]
            노출횟수 및 클릭횟수를 부정하게 생성하거나 증가시키는 행위#[br]
            "회사"의 서버 및 설비 등에 부하를 야기하는 행위#[br]
            기타 "서비스"의 정상적인 운영을 방해하는 행위#[br]
            ④ "광고주"는 "약관"에 따른 "회사"의 정당한 "서비스"를 제외하고는 "광고매체"의 다른 영역에서 "광고주" 또는 제3자의 영업을 홍보하기 위하여 검색서비스와 관련된 광고 또는 기타의 방법을 통한 광고를 할 수 없습니다.#[br]
            ⑤ "광고주"는 구매한 "스타일닷컴 광고" 및 이와 관련된 "서비스" 이용권한을 타인에게 대여하거나 양도하여서는 안되며, 타인이 구매한 "스타일닷컴 광고" 및 이와 관련된 "서비스" 이용권한을 대여받거나 양수하여서도 안 됩니다.#[br]
            ⑥ "광고주"는 자신의 "광고주계정"을 "회사"의 동의 없이 타인의 웹사이트, 상품, 서비스 또는 타인에 관한 정보 등을 광고하기 위한 목적으로 사용하여서는 안 됩니다.#[br]
            ⑦ "광고주"는 광고주 정보에 광고주 및 광고주 측의 직원이 아닌 타인의 정보 또는 허위의 정보를 기재해서는 안됩니다.#[br]
            ⑧ "광고주"는 "서비스"에 관한 자료와 입찰 등 게재신청에 대한 정보 등 "서비스" 이용과정에서 취득한 일체의 정보를 제3자에게 제공, 공개 또는 누설하여서는 안 됩니다.#[br]
            ⑨ "광고주"는 "서비스" 제공 또는 본 조 위반여부를 확인하기 위해 "회사"가 자료 또는 접근권한의 제공 및 관련사실에 대한 소명을 요청하는 경우에는 이에 성실히 임하여야 합니다.#[br]#[br]
            제 17 조 (스타일닷컴 광고 이용계약의 해지)#[br]
            ① "광고주"는 언제든지 "마케팅센터"에 접속하여 정액제 "스타일닷컴 광고" 이용계약의 해지를 신청할 수 있으며, 이 경우 신청일 다음 날에 해지됩니다. (영업일에만 해당)#[br]
            ② "광고주"가 전항에 따라 정액제 "스타일닷컴 광고" 이용계약을 해지하는 경우 "회사"는 남은 계약 기간만큼의 서비스 이용료를 환급하여 드립니다.#[br]#[br]
            제 18 조 (비즈머니의 충전, 환불, 소멸 등)#[br]
            ① "비즈머니"는 신용카드와 현금(이하 "현금 등"이라고 합니다)을 통해 충전이 가능합니다. "비즈머니"와 "현금 등"의 교환비율은 일대일(1:1)입니다.#[br]
            ② "회사"는 정액제 "키워드광고"의 이용계약이 취소 또는 해지될 경우 서비스이용료 등을 "비즈머니"로 환급하여 드립니다. 환급이라 함은 "광고주"의 "광고주계정"으로 해당 "비즈머니"를 돌려드리는 것을 의미합니다.#[br]
            ③ "회사"는 "광고주"가 "서비스" 이용 중단 등을 이유로 "비즈머니"의 환불을 요청하는 경우 "광고주계정"에 있는 "유상비즈머니"에 대해 환불합니다. 환불이라 함은 "광고주"가 충전한 수단에 따라 카드결제 취소 또는 현금으로 해당 금액을 돌려드리는 것을 의미합니다. 단, 카드 결제 취소의 경우 기 사용한 "서비스" 이용료를 결제한 후에 카드 결제 취소가 가능합니다.#[br]
            ④ "비즈머니"는 마지막으로 충전 또는 이용된 날로부터 5년이 경과하도록 다시 충전 또는 이용되지 않을 경우 상법 상의 상사소멸시효에 의해 광고운영정책에서 정하는 바에 따라 소멸될 수 있습니다.#[br]
            ⑤ "회사"는 "비즈머니"로 대체될수 있는 "비즈포인트"을 "광고주"에게 발행할 수 있습니다. "광고주"는 "비즈포인트"에 명시된 기간 및 조건에 따라서만 이를 사용할 수 있으며, 기간 내 미사용 시 해당 "비즈포인트"는 소멸됩니다.#[br]#[br]
            제 19 조 (키워드광고의 게재기간 등)#[br]
            ① 정액제 "스타일닷컴 광고"의 게재기간에 대한 사항은 아래와 같습니다.#[br]
            "광고주"가 신청한 "스타일닷컴 광고"의 게재기간을 변경하고자 할 경우 "회사"의 고객센터로 요청하여야 하며, 휴일에 요청한 건은 휴일 이후 첫 영업일에 접수된 것으로 봅니다.#[br]
            "광고주"가 자신의 사유로 "스타일닷컴 광고"의 일시적인 게재중단을 요청한 경우 게재가 중단된 기간은 게재기간에 포함되어 서비스 이용료가 부과됩니다.#[br]
            "광고주"의 서비스 이용료 지급 지연, 소명자료 미제출이나 "스타일닷컴 광고"의 심사 미통과, 재심사 등의 사유가 발생한 경우 정액제 "스타일닷컴 광고"는 게재되지 않으며 "스타일닷컴 광고" 이용계약이 취소될 수 있습니다.#[br]
            ② 종량제 "스타일닷컴 광고"의 게재기간에 대한 사항은 아래와 같습니다.#[br]
            "광고주"는 언제든지 "마케팅센터"에 접속하여 "스타일닷컴 광고"의 추가, 삭제, 게재, 게재 중지 등을 신청할 수 있습니다.#[br]
            "광고주"가 정상적인 서비스 이용을 위해 "비즈머니"를 사전에 충분히 충전하지 않은 경우 "스타일닷컴 광고"의 게재가 중단될 수 있으며, 이로 인해 발생하는 문제에 대한 책임은 "광고주"에게 있습니다.#[br]#[br]
            제 20 조 (이용제한 등)#[br]
            ① "회사"는 "광고주"가 관련 법령 및 "약관" 또는 광고운영정책에 따른 의무를 위반하는 경우 그 위반 횟수와 경중을 고려하여 "스타일닷컴 광고" 게재 신청 제한, "스타일닷컴 광고" 게재 제한, "서비스" 이용 정지, 제7조에 따라 체결된 "스타일닷컴 광고" 이용계약 해지, 제4조에 따라 등록된 "광고주" 직권 해지 등(이하 "이용제한"이라고 합니다)을 할 수 있습니다.#[br]
            ② "회사"는 제4조 제2항에 따른 승낙 취소 사유가 있는 것을 사후에 발견하였을 경우 "광고주"에게 "이용제한"을 할 수 있습니다.#[br]
            ③ "회사"는 제1항 또는 제2항에 따라 "이용제한"을 하는 경우 "광고주"가 "회사"와 이용계약을 체결하고 이용하는 "회사"의 다른 서비스(쇼핑몰순위, 상품수집 및 검색 등)에 대하여도 이용을 제한하거나 이용계약을 해지할 수 있으며 "회사"의 다른 서비스에서 이용이 제한되거나 계약이 해지된 경우 "스타일닷컴 광고" 서비스의 이용을 제한하거나 이용계약을 해지할 수 있습니다.#[br]
            ④ "회사"는 제1항 또는 제2항에 따라 "이용제한"을 하는 경우 제12조에서 정한 방법으로 "광고주"에게 통지합니다. 이 경우 "회사"는 "이용제한"을 하기 전에 상당한 기간을 정하여 "광고주"에게 이의신청의 기회를 부여하며, 다만 광고운영정책에서 정하는 사유가 있을 경우엔 별도의 이의 신청 기간을 부여하지 않을 수 있습니다.#[br]
            ⑤ "광고주"는 본 조에 따른 "이용제한"에 대하여 "회사"가 정하는 절차에 따라 이의신청을 할 수 있습니다. "회사"는 "광고주"의 이의가 정당하다고 인정할 경우 즉시 "이용제한"을 취소합니다.#[br]
            ⑥ "광고주"는 제5조를 준수하지 않아 본 조에 따라 "이용제한"을 받은 경우 "회사"가 정하는 절차에 따라 "광고주" 정보를 수정한 후 "이용제한"의 철회를 요청할 수 있습니다.#[br]
            ⑦ "회사"는 정액제 "스타일닷컴 광고"에 대해 "이용제한"을 하는 경우 남은 계약기간만큼의 서비스 이용료를 환급하여 드립니다.#[br]
            ⑧ "회사"는 "광고주"가 제15조 제6항을 위반하는 경우 "스타일닷컴 광고"의 대상이 된 웹사이트를 소유하거나 상품, 서비스를 제공하거나 "스타일닷컴 광고"의 대상이 된 자에게 해당 광고의 게재 내역에 관한 정보를 제공할 수 있습니다.#[br]#[br]
            제 21 조 (광고주 탈퇴)#[br]
            ① "광고주"는 언제든지 고객센터로 요청하거나 직접 "마케팅센터"에 접속하여 "약관" 제4조에 따라 가입한 "광고주" 탈퇴를 신청할 수 있으며, "회사"는 관련 법령이 정하는 바에 따라 이를 즉시 처리하여야 합니다.#[br]
            ② "광고주" 탈퇴가 완료되는 경우, "회사"는 관련 법령 및 개인정보취급방침에 따라 보유하는 "광고주"의 정보를 제외한 "광고주"의 모든 정보 및 "광고소재", 웹사이트 등 "스타일닷컴 광고"의 대상이 된 상품, 서비스 또는 그 제공자에 대한 정보를 즉시 삭제합니다. (단 광고시 이용되었던 정보만을 대상으로 하면 쇼핑몰순위에서의 정보나 일반상품 수집, 검색 정보등은 미삭제 될수 있습니다. 앞서 말했던 정보의 삭제까지 원하시는 경우 쇼핑몰삭제 신청을 "마케팅센터"로 접수하여 주시면 됩니다#[br]
            ③ "광고주" 탈퇴가 완료되는 경우 광고운영정책에서 정하는 바에 따라 탈퇴한 "광고주계정"의 정보로 다시 가입하는 것이 제한될 수 있습니다.#[br]#[br]
            제 22 조 (손해배상 등)#[br]
            ① "회사"는 "서비스" 이용과 관련하여 "회사"의 고의 또는 과실로 인해 "광고주"에게 손해가 발생한 경우 관련 법령이 규정하는 범위 내에서 "광고주"에게 그 손해를 배상합니다.#[br]
            ② "광고주"가 "약관" 또는 관련 법령을 위반하여 "회사"에 손해가 발생한 경우 관련 법령이 규정하는 범위 내에서 "회사"에 그 손해를 배상합니다.#[br]
            ③ "광고주"가 "약관" 또는 관련 법령을 위반하여 제3자가 "회사"를 상대로 민·형사상의 법적 조치를 취하는 경우 "광고주"는 자신의 책임과 비용으로 "회사"를 면책시키고 이로 인해 "회사"에 발생한 손해를 배상합니다.#[br]#[br]
            제 23 조 (책임제한)#[br]
            ① "회사"는 천재지변, 디도스(DDOS)공격, IDC장애, 기간통신사업자의 회선 장애, "광고매체"의 장애 또는 이에 준하는 불가항력으로 인하여 "서비스"를 제공할 수 없는 경우에는 "서비스" 제공에 관한 책임을 지지 않습니다.#[br]
            ② "회사"는 "광고주"의 귀책사유로 인한 "서비스" 이용 장애에 대하여는 책임을 지지 않습니다.#[br]
            ③ "회사"는 "광고주"가 "서비스"와 관련하여 제공한 "광고소재" 또는 해당 "키워드광고"의 대상이 된 웹사이트, 상품, 서비스 또는 그 제공자의 신뢰도, 정확성, 적법성 등에 관하여는 책임을 지지 않습니다.#[br]
            ④ "회사"는 "광고매체" 및 "광고매체"에서 노출되는 검색결과 또는 콘텐츠의 신뢰도, 정확성, 적법성 등에 관하여 보증하지 않습니다. 다만, "광고매체"가 관련 법령 또는 "회사"의 광고매체정책을 위반하는 경우 "회사"는 해당 "광고매체"에 광고를 게재하지 않을 수 있으며, 해당 "광고매체"에 광고 게재 또는 게재 중단과 관련하여 "회사"는 책임을 지지 않습니다.#[br]
            ⑤ "회사"는 "광고매체"에서 노출되는 검색결과 또는 콘텐츠가 "광고주"에게 우호적인 내용으로 구성되어 있음을 보증하지 않으며, "광고주"에게 부정적인 내용으로 구성된 검색결과 또는 콘텐츠와 함께 광고가 게재된 것에 대하여 "회사"는 책임을 지지 않습니다.#[br]
            ⑥ "회사"는 광고 효과 향상을 위해 "광고주"에게 "스타일닷컴 광고" 노출 조건(제한IP 등) 설정기능을 제공할 수 있으며, "광고주"가 설정한 조건에 따라 "스타일닷컴 광고"가 미과금 될 수 있도록 최선을 다합니다. 단, "회사"는 "광고주"가 설정한 조건에 따라 모든 "스타일닷컴 광고"가 노출됨을 보증하지 아니하며, 설정된 조건과 다르게 노출되는 "스타일닷컴 광고"에 대하여 "회사"는 책임을 지지 않습니다.#[br]
            ⑦ "회사"는 광고운영의 편의를 위해 "광고주"에게 광고 조건(기간, 이용료 등)을 설정하면 시스템에 따라 자동으로 광고 게재 및 광고 관리를 할 수 있는 기능을 제공할 수 있습니다. "광고주"가 해당 기능을 이용하여 자동 광고 운영을 신청하는 경우 "회사"는 이에 따라 광고를 게재하며, "회사"는 자동 광고 운영 결과에 대하여 책임을 지지 않습니다.#[br]#[br]
            제 24 조 (약관의 해석)#[br]
            ① "회사"는 "약관" 외에 별도의 광고운영정책 등을 둘 수 있습니다.#[br]
            ② "약관"에서 정하지 않은 사항이나 해석에 대하여는 광고운영정책, 이용안내, 관련 법령에 따릅니다.#[br]#[br]
            제 25 조 (준거법 및 재판관할)#[br]
            ① "회사"와 "광고주" 간에 발생한 분쟁에 대하여는 대한민국법을 준거법으로 합니다.#[br]
            ② "회사"와 "광고주" 간 발생한 분쟁에 관한 소송은 민사소송법 상의 관할법원에 제소합니다.#[br]#[br]
            [부칙]#[br]
            본 약관은 2013년 9월 1일부터 시행됩니다.#[br]
            2011년 7월 1일부터 시행되던 종전의 약관은 본 약관으로 대체됩니다.
        el-checkbox.checkbox(v-model="terms") 서비스 이용약관 동의
      .terms-item
        .terms-box
          .terms-box-header
            p.terms-box-title 개인정보 취급방침
            p.date 2018.01.01 시행
          .terms-box-body.
            1. 수집하는 개인정보의 항목 및 수집방법#[br]
            가. 수집하는 개인정보의 항목#[br]
            첫째, 회사는 회원(또는 서비스) 가입, 원활한 고객상담, 각종 서비스의 제공 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.#[br]
            [마케팅센터 광고]#[br]
            1.1 회원정보#[br]
            - 필수항목 : 회원 ID, 비밀번호, 비밀번호 확인, 광고 담당자명, 광고 담당자 이메일, 회사 전화번호, 광고 담당자 직통번호, 광고 담당자 핸드폰번호, 업체명, 사업자 등록번호, 대표자명, 업태, 종목, 대표자 직통번호, 대표자 핸드폰 번호, 사업장 주소, 세금계산서업무 담당자 이메일, 입금은행, 비즈머니잔액 알림#[br]
            1.2 쇼핑몰 정보#[br]
            - 필수항목: 쇼핑몰명, 쇼핑몰URL, 쇼핑몰 연결 URL, 쇼핑몰 설명문구, 쇼핑몰 분류, 연령대 선택, 스타일 선택, 테마별 선택, 전문샵 선택, 사업자 등록증 첨부, 쇼핑몰 대표 이미지, 스타일닷컴을 알게된 경로, 한달 지출 광고비#[br]
            - 선택항목 : 쇼핑몰 하루 순수 방문자수/페이지뷰#[br]
            둘째, 서비스 이용과정이나 서비스 제공 업무 처리 과정에서 아래와 같은 정보들이 자동으로 생성되거나 추가로 수집될 수 있습니다.#[br]
            - IP Address, 쿠키, 접속로그, 방문 일시, 서비스 이용 기록, 불량 이용 기록, 결제기록#[br]
            나. 개인정보 수집방법#[br]
            회사는 다음과 같은 방법으로 개인정보를 수집합니다.#[br]
            - 홈페이지, 서면양식, 팩스, 전화, 상담 게시판, 이메일, 이벤트 응모#[br]
            - 생성정보 수집 툴을 통한 수집#[br]
            2. 개인정보의 수집 및 이용목적#[br]
            가. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산 컨텐츠 제공, 특정 맞춤 서비스 제공, 본인인증, 요금 결제, 요금추심#[br]
            나. 회원관리#[br]
            회원제 서비스 이용 및 제한적 본인 확인제에 따른 본인확인, 개인식별, 불량회원의 부정 이용방지와 비인가 사용방지, 가입의사 확인, 가입 및 가입횟수 제한, 만14세 미만 아동 개인정보 수집 시 법정 대리인 동의여부 확인, 추후 법정 대리인 본인확인, 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달#[br]
            다. 신규 서비스 개발 및 마케팅?광고에의 활용#[br]
            신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 접속빈도 파악, 회원의 서비스이용에 대한 통계#[br]
            3. 개인정보의 보유 및 이용기간#[br]
            이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.#[br]
            가. 회사 내부 방침에 의한 정보보유 사유#[br]
            [마케팅센터 광고]#[br]
            - 부정이용기록#[br]
            보존 이유 : 부정 이용 방지 및 이용자 보호#[br]
            보존 기간 : 3년#[br]
            나. 관련법령에 의한 정보보유 사유#[br]
            상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래의 예시와 같습니다.#[br]
            - 계약 또는 청약철회 등에 관한 기록#[br]
            보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률#[br]
            보존 기간 : 5년#[br]
            - 대금결제 및 재화 등의 공급에 관한 기록#[br]
            보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률#[br]
            보존 기간 : 5년#[br]
            - 세법이 규정하는 모든 거래에 관한 장부 및 증빙서류#[br]
            보존 이유 : 국세기본법, 법인세법#[br]
            보존 기간 : 5년#[br]
            - 소비자의 불만 또는 분쟁처리에 관한 기록#[br]
            보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률#[br]
            보존 기간 : 3년#[br]
            - 본인확인에 관한 기록#[br]
            보존 이유 : 정보통신망 이용촉진 및 정보보호 등에 관한 법률#[br]
            보존 기간 : 6개월#[br]
            - 표시/광고에 관한 기록#[br]
            보존 이유 : 정보통신망 이용촉진 및 정보보호 등에 관한 법률#[br]
            보존 기간 : 6개월#[br]
            - 방문에 관한 기록#[br]
            보존 이유 : 통신비밀보호법#[br]
            보존 기간 : 3개월
        el-checkbox.checkbox(v-model="privacy") 개인정보 취급방침 동의
    .validation-section
      p.validation-section-title 사업자 인증
      form.form
        div.business-nubmer-input.el-input
          input.el-input__inner(
            v-model="companyNumber",
            ref="companyNumber",
            placeholder="사업자 번호",
            maxlength="10",
            @keypress="onlyNumber",
            :readonly="isCompanyNumber")
        el-button.auth-button(size="medium", @click="companyNumberCheck") 인증
    .next-button-wrapper
      el-button.next-button(@click="goToForm", type="info") 다음
</template>

<script>
export default {
  data() {
    return {
      terms: false,
      privacy: false,
      companyNumber: null,
      isCompanyNumber: false,
    };
  },
  methods: {
    // 숫자만 입력
    onlyNumber(e) {
      const keyCode = (e.keyCode ? e.keyCode : e.which);
      if (keyCode < 48 || keyCode > 57) {
        e.preventDefault();
      }
    },

    // 사업자 번호 유효성 체크
    companyNumberCheck() {
      if (this.companyNumber === null || this.companyNumber === '') {
        this.$alert('사업자 번호를 입력해주세요.', {
          confirmButtonText: '확인',
          callback: () => {
            this.$refs.companyNumber.focus();
          },
        });
      } else {
        const comNum = this.companyNumber;
        if (comNum.length !== 10) {
          this.isCompanyNumber = false;
        } else {
          let sumMod = 0;
          sumMod += parseInt(comNum.substring(0, 1), 10);
          sumMod += (parseInt(comNum.substring(1, 2), 10) * 3) % 10;
          sumMod += (parseInt(comNum.substring(2, 3), 10) * 7) % 10;
          sumMod += (parseInt(comNum.substring(3, 4), 10) * 1) % 10;
          sumMod += (parseInt(comNum.substring(4, 5), 10) * 3) % 10;
          sumMod += (parseInt(comNum.substring(5, 6), 10) * 7) % 10;
          sumMod += (parseInt(comNum.substring(6, 7), 10) * 1) % 10;
          sumMod += (parseInt(comNum.substring(7, 8), 10) * 3) % 10;
          sumMod += Math.floor(parseInt(comNum.substring(8, 9), 10) * 5 / 10);
          sumMod += (parseInt(comNum.substring(8, 9), 10) * 5) % 10;
          sumMod += parseInt(comNum.substring(9, 10), 10);
          if (sumMod % 10 !== 0) {
            this.isCompanyNumber = false;
          } else {
            this.isCompanyNumber = true;
          }
        }
        console.log(this.isCompanyNumber);

        if (!this.isCompanyNumber) {
          this.$alert('올바르지 않은 사업자 번호 입니다.', {
            confirmButtonText: '확인',
          });
        } else {
          this.$alert('사업자 번호가 인증 되었습니다. 다음으로 넘어가 주세요.', {
            confirmButtonText: '확인',
          });
        }
      }
    },

    // 다음 단계
    goToForm() {
      if (!this.terms || !this.privacy) {
        this.$alert('동의에 모두 체크해주세요.', {
          confirmButtonText: '확인',
        });
        return;
      }
      if (!this.isCompanyNumber) {
        this.$alert('사업자 번호 인증을 해주세요.', {
          confirmButtonText: '확인',
        });
        return;
      }
      this.$store.commit('setCompanyNumber', this.companyNumber);
      // this.$router.push({ path: '/register/form', query: { companyNumber: this.companyNumber } });
      this.$router.push('/register/form');
    },
  },
};
</script>
